import { useOnceStore } from '@apps-once/store';

export function formatPrice(price: number, { precision = 2 } = {}): string {
  const currencySymbol = useOnceStore().currencySymbol;

  const formattedNumber = Number(price).toLocaleString('en-US', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
  return `${currencySymbol}${formattedNumber}`;
}
